
import React, {FC} from 'react';
import {Form as _Form} from 'react-bootstrap';
import Button from 'components/Button';
import {InputField} from 'components/forms/InputField';
import {Formik} from 'formik';

import {validationSchema} from './validations';

import * as styles from './styles.module.scss';

type FormProps = {
	children: React.ReactNode
	loading: boolean
	onSubmit: (values?: FormValues) => void
}

export type FormValues = {
	firstName: string
	lastName: string
	email: string
}

export const Form: FC<FormProps> = ({children, loading, onSubmit}) => (
	<Formik<FormValues>
		initialValues={{
			firstName: '',
			lastName: '',
			email: '',
		}}
		onSubmit={onSubmit}
		validationSchema={validationSchema}
	>
		{({handleSubmit}) => (
			<_Form className={styles.form} onSubmit={handleSubmit}>
				<InputField
					label='First name'
					name='firstName'
					placeholder='First name'
				/>
				<InputField
					label='Last name'
					name='lastName'
					placeholder='Last name'
				/>
				<InputField
					label='Email'
					name='email'
					placeholder='Email'
				/>
				<Button
					variant='primary'
					type='submit'
					disabled={loading}
				>
					{children}
				</Button>
			</_Form>
		)}
	</Formik>
);
